<h1>
  <span>{{ 'search.results' | translate }}: {{ searchService.getResultIndexFrom() }} - {{ searchService.getResultIndexTo() }}</span>
  <span class="app-slash">/</span>
  <span class="app-all">{{searchService.getNumberOfResults()}}</span>
</h1>